export default __webpack_public_path__ + "static/media/ico-error-status.de33deda.svg";